import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { FiShield, FiMail, FiUserPlus } from 'react-icons/fi'
import adminApi from '../../api/adminApi'
import FormInput from '../../components/FormInput/FormInput'
import Select from '../../components/Select/Select'
import Button from '../../components/Button/Button'
import './InviteStaff.css'

const ROLE_OPTIONS = [
  { value: 'mentor', label: 'Mentor' },
  { value: 'batch manager', label: 'Batch Manager' },
  { value: 'doubt solver', label: 'Doubt Solver' },
  { value: 'admin', label: 'Admin' },
]

const InviteStaff = () => {
  const { user } = useSelector((state) => state.auth)
  const [formData, setFormData] = useState({
    email: '',
    role: '',
    expiresInDays: 7,
  })
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)

  // Only superadmin can invite
  if (user?.role !== 'superadmin') {
    return (
      <div className="invite-staff-page">
        <div className="access-denied">
          <FiShield size={48} />
          <h2>Access Denied</h2>
          <p>Only Super Admins can invite staff members.</p>
        </div>
      </div>
    )
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    setSuccess(false)

    try {
      await adminApi.post('/invite', formData)
      setSuccess(true)
      setFormData({
        email: '',
        role: '',
        expiresInDays: 7,
      })
      setTimeout(() => setSuccess(false), 5000)
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send invite')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="invite-staff-page">
      <header className="page-header">
        <div>
          <p className="eyebrow">Staff Management</p>
          <h1>Invite Staff Member</h1>
          <p className="subhead">Send invitation emails to new staff members</p>
        </div>
      </header>

      <section className="invite-section">
        <div className="section-header">
          <FiUserPlus size={20} />
          <h2>Create Invitation</h2>
        </div>

        {success && (
          <div className="success-message">
            <FiMail size={20} />
            <div>
              <strong>Invitation sent!</strong>
              <p>An invitation email has been sent to {formData.email}</p>
            </div>
          </div>
        )}

        {error && (
          <div className="error-message" role="alert">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="invite-form">
          <FormInput
            label="Email Address"
            name="email"
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="staff@example.com"
            required
          />

          <Select
            label="Role"
            name="role"
            value={formData.role}
            onChange={(e) => setFormData({ ...formData, role: e.target.value })}
            options={ROLE_OPTIONS}
            required
            placeholder="Select role"
          />

          <FormInput
            label="Expires In (Days)"
            name="expiresInDays"
            type="number"
            value={formData.expiresInDays}
            onChange={(e) => setFormData({ ...formData, expiresInDays: parseInt(e.target.value) || 7 })}
            min="1"
            max="30"
          />

          <Button type="submit" loading={loading} fullWidth>
            <FiMail size={18} />
            Send Invitation
          </Button>
        </form>
      </section>
    </div>
  )
}

export default InviteStaff

